module.exports = __webpack_public_path__ + "static/l02-61eb71b15a625202abd5de9b7baf74e8.png";